module.exports = __webpack_public_path__ + "static/endpoint-yellow-22dedf5ab9e11dc1064fc6c5dd2fd6f7.png";